<template>
  <portal-target name="modal" multiple />
</template>

<script>
export default {
  name: 'modal-target',
};
</script>
